<template>
    <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" persistent>
        <q-card style="max-width: 90vw; width: 90vw; max-height: 90vh">
            <q-card-section class="row items-center q-pb-none">
                <div class="text-h6">Observaciones</div>
                <q-space />
                <q-btn icon="close" flat round dense v-close-popup />
            </q-card-section>
            <q-separator />
            <q-card-section class="scroll">
                <q-table
                    :rows="observaciones"
                    :columns="columns"
                    row-key="id"
                    flat
                    dense
                    class="observaciones-table"
                >
                    <template v-slot:body-cell-created_at="props">
                        <q-td :props="props">
                            {{ props.row.created_at ? format(new Date(props.row.created_at), 'dd/MM/yyyy HH:mm') : 'N/A' }}
                        </q-td>
                    </template>
                </q-table>
            </q-card-section>
            <q-separator />
            <q-card-actions align="right">
                <q-btn flat label="Cerrar" color="primary" v-close-popup />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup>
import { format } from 'date-fns'

defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
    observaciones: {
        type: Array,
        default: () => [],
    },
})

defineEmits(['update:modelValue'])

const columns = [
    {
        name: 'id',
        label: 'ID',
        field: 'id',
        align: 'left',
        sortable: true,
    },
    {
        name: 'detalle',
        label: 'Detalle',
        field: 'detalle',
        align: 'left',
        sortable: false,
    },
    {
        name: 'user_id',
        label: 'Usuario ID',
        field: 'user_id',
        align: 'left',
        sortable: true,
    },
    {
        name: 'presupuesto_id',
        label: 'Presupuesto ID',
        field: 'presupuesto_id',
        align: 'left',
        sortable: true,
    },
    {
        name: 'created_at',
        label: 'Fecha Creación',
        field: 'created_at',
        align: 'left',
        sortable: true,
    },
]
</script>

<style lang="scss" scoped>
.observaciones-table {
    :deep(.q-table__card) {
        box-shadow: none;
        background: transparent;
    }

    :deep(.q-table thead th) {
        font-weight: 600;
        font-size: 13px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        background: #fafafa;
        color: #424242;
    }

    :deep(.q-table tbody tr) {
        transition: all 0.2s ease;

        &:hover {
            background: #f5f9ff;
        }
    }

    :deep(.q-table tbody td) {
        border-bottom: 1px solid #f0f0f0;
    }
}
</style>
